import { useEffect, useState } from 'react';
import { ModalArea } from '../../common/ModalButtonArea';
import { Input } from '../../common';
import Button from '../../components/Button';
import { errorToast } from '../../helpers/toastHelper';

export const ShowRenameModel = ({
  show,
  onClose,
  activeTab,
  onSubmit,
  preventFromClosing = false,
}) => {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setName(activeTab?.name);
  }, [activeTab]);

  const handleName = ({ name, value }) => setName(value);

  const handleSubmit = async () => {
    const _name = name.trim();
    if (!_name) {
      errorToast('Name is required.');
      setName('');
      return;
    }
    if (_name === activeTab?.name) {
      onClose();
      return;
    }
    setLoading(true);
    const formData = new FormData();
    formData.append('name', _name);
    formData.append('description', _name);
    await onSubmit?.(formData);
    setLoading(false);
  };

  return (
    <ModalArea
      size="md"
      showModal={show}
      setShowModal={onClose}
      animation={true}
      centered={true}
      title="Rename your video"
      {...(preventFromClosing ? { backdrop: 'static' } : {})}
      body={
        <div style={{ padding: '1rem 0 0', minHeight: 150 }}>
          <Input
            label={'Name'}
            className={`mb-3 w-100 my-details-input ${!name ? 'input-error' : ''}`}
            name="name"
            onChange={handleName}
            maxLength={50}
            required
            value={name}
            errorData={[!name ? 'Name is required!' : '']}
            style={{ borderRadius: 3 }}
            onKeyDown={(e) => {
              if (e.key !== 'Enter') return;
              handleSubmit();
            }}
          />
          <Button onClick={handleSubmit} fullWidth size="xlg" loading={loading}>
            Submit
          </Button>
        </div>
      }
    />
  );
};
